import { z } from "zod";
import { LVPositionSchema } from "./02-lv-positionen.js";
import { PfadSchema } from "./common.js";

/**
 * Phase 3 — Vereinheitlichung A/B. Hier ist die Position-Liste die
 * Single Source of Truth für alle nachgelagerten Phasen (Match, Preise, Export).
 *
 * `provisional`-Marker bleibt erhalten, damit Innendienst weiß welche Mengen
 * vom Kunden kommen und welche aus der Plan-Engine.
 */
export const KonsolidiertePositionSchema = LVPositionSchema.extend({
  /** Eindeutige ID innerhalb der Anfrage. Format `pos-<6-stellig>`. */
  positionId: z.string().regex(/^pos-\d{6}$/),
});
export type KonsolidiertePosition = z.infer<typeof KonsolidiertePositionSchema>;

export const AnfrageKonsolidiertSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  pfad: PfadSchema,
  positionen: z.array(KonsolidiertePositionSchema).default([]),
  duplikateEntfernt: z.number().int().nonnegative().default(0),
});

export type AnfrageKonsolidiert = z.infer<typeof AnfrageKonsolidiertSchema>;
